export default function () {
  const btns = document.getElementsByClassName("go-to-top-btn");
  for (const btn of btns) {
    btn.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
}
